<p-dialog
  [(visible)]="display"
  [style]="{ width: '50vw' }"
  (onHide)="cancel()"
  [modal]="true"
  [header]="'Revoke Training Items: ' + skillName"
>
  <ng-container *ngIf="!isLoading">
    <div *ngIf="errorMessages.length > 0" class="error-container">
      <p-messages severity="error">
        <ng-template pTemplate="content">
          <span class="p-message-icon pi pi-times-circle"></span>
          <span class="p-ml-2">Please correct the following errors:</span>
          <ul>
            <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
          </ul>
        </ng-template>
      </p-messages>
    </div>

    <p class="revocation-description">
      To remove a Skill that was assigned automatically to a user, you need to revoke at least one of the Training Requirements that are linked to the Skill for that user.
    </p>

    <!-- Revocation Reason -->
    <div class="field field-required">
      <bpt-text-input
        [highlightAllOnFocus]="true"
        placeholder="Enter the revocation reason..."
        [multiLine]="true"
        id="revocationReasonInput"
        label="Revocation Reason"
        [(ngModel)]="removalReason"
        [required]="true"
      ></bpt-text-input>
    </div>

    <!-- Training Items Selection -->
    <div
      class="field field-required"
    >
      <label>Linked Training Items</label>
      <div class="training-items-container">
        <div *ngFor="let item of trainingItems" class="checkbox-item">
          <p-checkbox
            [(ngModel)]="selectedItemIds"
            [value]="item.trainingItemId"
            [label]="item.trainingItemId + ':' + item.title"
            id="trainingItem_{{ item.trainingItemId }}"
            [required]="true"
          ></p-checkbox>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template pTemplate="footer">
    <p-button
      appPreventDoubleClick
      label="Cancel"
      type="button"
      id="revocationCancelButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="cancel()"
    ></p-button>
    <p-button
      appPreventDoubleClick
      label="Revoke"
      type="submit"
      id="revocationConfirmButton"
      class="align-right"
      (debounceClick)="saveRevocation()"
      [disabled]="isLoading"
    ></p-button>
  </ng-template>
</p-dialog>
